/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/platform/design-system/hooks/useReducedMotion.ts
 * layer: web
 * area: hooks
 * kind: hook
 * web_root: hooks
 * relpath: web/src/platform/design-system/hooks/useReducedMotion.ts
 * filename: useReducedMotion.ts
 * extension: ts
 * ---
 * hyperion-index:end
 */

import { useState, useEffect } from 'react';

/**
 * Returns true when the user prefers reduced motion (OS accessibility setting).
 * Useful for disabling animations and transitions.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduced;
}
